export default __webpack_public_path__ + "static/media/sc-pin-active-ico.514c8de9.svg";